import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

export default class Brochure extends React.Component {
    
    state = {
        //Page 1
        welcome:this.props.fields.WelcomeMessage,
        brochureDate:this.props.fields.BrochureDate,
        mission:this.props.fields.MissionStatement,

        //Page 2
        logoIcon:this.props.fields.Logo,
        getInTouch:this.props.fields.TopSection,
        socialIcons:this.props.fields.SocialIcons,
        socialHandles:this.props.fields.SocialHandles,
        address:this.props.fields.BottomSection,

        //Page 3
        ac:this.props.fields.ApostlesCreed,

        //Page 4
        ctw:this.props.fields.CallToWorship,

        //Page 5
        cs:this.props.fields.confessionOfSin,
        ap:this.props.fields.assuranceOfPardon,
        hc:this.props.fields.HeidelbergCatechism,

        //Optional: Praise
        praiseOn:this.props.fields.praiseOn,
        p1:this.props.fields.praise1,
        p2:this.props.fields.praise2,

        //Page 6
        pp:this.props.fields.PraiseAndPrayer,
        dox:this.props.fields.Doxology,
        scripture:this.props.fields.ScriptureReading,
        cp:this.props.fields.CongregationalPrayer,
        sermon:this.props.fields.Sermon,
        ref:this.props.fields.ReflectionAndResponse,

        //Optional: Response
        responseOn:this.props.fields.responseOn,
        r:this.props.fields.response,

        //Page 7
        ca:this.props.fields.ChurchAnnouncements,
        lp:this.props.fields.LordsPrayer
    }

    options = {
        preserveWhitespace: true,
    };

    render(){
        return (
            <div className='brochure'>
                <div className='pages grp1'>
                    <div className='page page1' 
                        style={{
                            backgroundImage:'url(https://images.ctfassets.net/i9rifi7heelg/4Qim1R6OC3xjJ1iZjQ7Fto/1e54d733b12810eb769a98523cc804a8/sgfbg.jpg)',
                            backgroundPosition: '0',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                        }}
                    >
                        <div className='welcome'>
                            {documentToReactComponents(this.state.welcome, this.options)}
                            <div className='date'>
                                {this.state.brochureDate}
                            </div>
                        </div>
                        <div className='mission'>
                            {documentToReactComponents(this.state.mission, this.options)}
                        </div>
                    </div>
                    <div className='page page2'>
                        <div className='icon'>
                            <img src={this.state.logoIcon.fields.file.url}/>
                        </div>
                        <div className='getInTouch'>
                            {documentToReactComponents(this.state.getInTouch, this.options)}
                        </div>
                        <div className='socials'>
                            {
                                this.state.socialHandles.length === this.state.socialIcons.length ?
                                this.state.socialHandles.map((handle, i) => {
                                    return <div key={"soc"-i} className='social'>
                                        <img className='icon' src={this.state.socialIcons[i].fields.file.url}/>
                                        <div className='handle'>{handle}</div>
                                    </div>
                                }) : ""
                            }
                        </div>
                        <div className='address'>
                            {documentToReactComponents(this.state.address, this.options)}
                        </div>
                    </div>
                </div>
                <div className='pages grp2'>
                    <div className='page page3'>
                        <div className='ac'>
                            {documentToReactComponents(this.state.ac, this.options)}
                        </div>
                    </div>
                    <div className='page page4'>
                        <div className='ctw'>
                            {documentToReactComponents(this.state.ctw, this.options)}
                        </div>
                    </div>
                </div>
                <div className='pages grp3'>
                    <div className='page page5'>
                        <div className='cs'>
                            {documentToReactComponents(this.state.cs, this.options)}
                        </div>
                        <div className='ap'>
                            {documentToReactComponents(this.state.ap, this.options)}
                        </div>
                        <div className='hc'>
                            {documentToReactComponents(this.state.hc, this.options)}
                        </div>
                    </div>
                    <div className='page page6'>
                        <div className='pp'>
                            {documentToReactComponents(this.state.pp, this.options)}
                        </div>
                        <div className='dox'>
                            {documentToReactComponents(this.state.dox, this.options)}
                        </div>
                        <div className='scripture'>
                            {documentToReactComponents(this.state.scripture, this.options)}
                        </div>
                        <div className='cp'>
                            {documentToReactComponents(this.state.sermon, this.options)}
                        </div>
                        <div className='sermon'>
                            {documentToReactComponents(this.state.cp, this.options)}
                        </div>
                        <div className='ref'>
                            {documentToReactComponents(this.state.ref, this.options)}
                        </div>
                    </div>
                </div>
                <div className='pages grp4'>
                    <div className='page page7'>
                        <div className='ca'>
                            {documentToReactComponents(this.state.ca, this.options)}
                        </div>
                    </div>
                    <div className='page page8'>
                        <div className='lp'>
                            {documentToReactComponents(this.state.lp, this.options)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}